import React from "react";

export function PlayButton({ onClick, progress = 0 }) {
  // Normalize progress (0–100) into [0,1]
  const normalizedProgress = Math.min(Math.max(progress / 60, 0), 1);
  // Outer ring radius and circumference
  const radius = 112;
  const circumference = 2 * Math.PI * radius;

  return (
    <button
      onClick={onClick}
      className="relative w-full max-w-[286px] aspect-[286/276] focus:outline-none"
    >
      <svg
        width="286"
        height="276"
        viewBox="0 0 286 276"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto"
      >
        {/* Static grey ring halves */}
        <path
          d="M143 26C113.296 26 84.8081 37.8 63.804 58.804C42.8 79.8081 31 108.296 31 138C31 167.704 42.8 196.192 63.804 217.196C84.8081 238.2 113.296 250 143 250V238.8C116.266 238.8 90.6273 228.18 71.7236 209.276C52.82 190.373 42.2 164.734 42.2 138C42.2 111.266 52.82 85.6273 71.7236 66.7236C90.6273 47.82 116.266 37.2 143 37.2V26Z"
          fill="#D3DCEE"
        />
        <path
          d="M143 250C172.704 250 201.192 238.2 222.196 217.196C243.2 196.192 255 167.704 255 138C255 108.296 243.2 79.8081 222.196 58.8041C201.192 37.8 172.704 26 143 26V37.2C169.734 37.2 195.373 47.82 214.276 66.7237C233.18 85.6273 243.8 111.266 243.8 138C243.8 164.734 233.18 190.373 214.276 209.276C195.373 228.18 169.734 238.8 143 238.8V250Z"
          fill="#D3DCEE"
        />
        {/* Animated circular progress */}
        <circle
          cx="143"
          cy="138"
          r={radius}
          fill="none"
          stroke="#4979D1"
          strokeWidth="8"
          strokeLinecap="round"
          transform="rotate(-90 143 138)"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - normalizedProgress)}
          style={{ transition: "stroke-dashoffset 0.5s linear" }}
        />

        {/* Static inner elements */}
        <g filter="url(#filter0_d_94_466)">
          <rect
            x="117"
            y="105"
            width="66.3"
            height="66.3"
            fill="url(#pattern0_94_466)"
            shapeRendering="crispEdges"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M142.757 217.513C186.805 217.513 222.513 181.805 222.513 137.757C222.513 93.7083 186.805 58 142.757 58C98.7083 58 63 93.7083 63 137.757C63 181.805 98.7083 217.513 142.757 217.513ZM142.757 196.245C175.059 196.245 201.245 170.059 201.245 137.757C201.245 105.455 175.059 79.2687 142.757 79.2687C110.454 79.2687 84.2684 105.455 84.2684 137.757C84.2684 170.059 110.454 196.245 142.757 196.245Z"
          fill="#D9D9D9"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.5 265C213.916 265 271 207.916 271 137.5C271 67.0837 213.916 10 143.5 10C73.0837 10 16 67.0837 16 137.5C16 207.916 73.0837 265 143.5 265ZM143.5 263.242C212.459 263.242 268.362 207.339 268.362 138.38C268.362 69.4202 212.459 13.5176 143.5 13.5176C74.5406 13.5176 18.638 69.4202 18.638 138.38C18.638 207.339 74.5406 263.242 143.5 263.242Z"
          fill="#D9D9D9"
          fillOpacity="0.5"
        />
        <defs>
          <filter
            id="filter0_d_94_466"
            x="113"
            y="105"
            width="74.3"
            height="74.2998"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.47451 0 0 0 0 0.819608 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_94_466"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_94_466"
              result="shape"
            />
          </filter>
          <pattern
            id="pattern0_94_466"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlinkHref="#image0_94_466"
              transform="scale(0.01)"
            />
          </pattern>
          <image
            id="image0_94_466"
            width="100"
            height="100"
            preserveAspectRatio="none"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCUlEQVR4nO2dPYtTQRSGr4jY+NVZCdqqjdhro2aOooKa1nK7LTVz3CKtraDo/oWtxcL1Bygs5pz4BWtjoRa6VopgQK9cMYkG/FqTnXNm3gdOG2Z4mJl73zuZqSoAAAAAAAAAAABkRuje30EsNyjqa2JZI5bFEwuP9qRuV7GEKHeItf6xQpRPxHrtbLe3K3X7iqJ1uXdgUsZPFeVdiP1OmF/dmrqtRdBiOfdbIaMRo6vUkfNVVW9K3easCbHf/hsh4xGjD0529EjqdmfLPwsZlSw3013q9mfH+oV8q0HzRHaa+7tT9yMb/lPIcOF/TyxXj3Yfb0vdH/dMRch44X8ZYn+u3V7anLpfbpmmEBov/E+a303dN5fMRAiPF/7QkUOp++iK2QrR5o3/M7EstTq9van76oJZC6GxGEQxloTQaH1BFGNLCA9HjL6gK3IRUYwRITQaMYhibAnhYSGKMSZEm0IUY0xITaVHMSaFcMFRjGUhVGIU40IIFxTF+BKioyjm+ILsq3LEmxDKPYrxKoRyjWLcC+HMophchFAuUUx2Qth5FJOvEPUZxWQupP5eH9xEMYUIqd1EMSUJoaEYlqdmo5gShZDlKKZsIdpI+WIqioEQtRXFQIjaimIgRH81lT0PrBcghO0t/GcuPduOEcKmpCxCCJsSsgYhnFoChNRmK+otjBA2835yd0NDSTz2qq0vkBCiE9MTXgxrI1MTohMyIALhIpuanu4hfuf0IvCBio2IwCdcNbXJYUNDwvWS+WPvANuA2ErJ8imWg5U3shshEVtJ00tgbLY2NCIEf0dILoENRR3Txt8aIrb2UZUtROztNCxRSLC8F7ckIcFD1FGEkIijNWojNXAXdeQ7QsTnfwKzExKdRx3TBkf8GQOHYBoDx8QaAwcpGwNHjRsDh/EbA9dVGAMXuhgDVx4ZA5eCGQPX5hkDF0saI/DD/X8I/94ElvnDcytbUre1GCjq7UkRgfVjsx/2WGdlZ+r2FUezCTlEuU6srwLr28B6E9d3AwAAAAAAAAAAoHLPV3fvYapjj94cAAAAAElFTkSuQmCC"
          />
        </defs>
      </svg>
    </button>
  );
}